import type { GameMeta } from "../../common/gameMeta.js";
import type { HueHuntVariantConfig } from "./variantConfig.js";

export const meta = {
	name: "Hue Hunt",
	minPlayers: 1,
	maxPlayers: 4,
	description: "Sort a grid of color tiles into a seamless gradient.",
	instructions: "Swap tiles until similar hues sit side-by-side. The four corner tiles are locked — use them as anchors and work inward!",
	mobileBrowserCompatible: true,
	modifiers: [
		{
			id: "spectrum",
			label: "Spectrum",
			instructions: "Sort the tiles into a rainbow — hue shifts left to right, brightness shifts top to bottom.",
			config: { gradientStyle: "spectrum" } satisfies Partial<HueHuntVariantConfig>,
		},
		{
			id: "largeGrid",
			label: "Large Grid",
			instructions: "The grid is doubled — 8 columns and 12 rows. A lot more to sort.",
			config: { gridCols: 6, gridRows: 9 } satisfies Partial<HueHuntVariantConfig>,
		},
	],
} satisfies GameMeta;
